import React from "react";
import { Link } from "react-router-dom";
import { Grid, Paper, Typography, Box } from "@mui/material";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import CollectionsRoundedIcon from "@mui/icons-material/CollectionsRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

const cards = [
  { label: "Construction Update", to: "/admin/construction", icon: <ConstructionRoundedIcon fontSize="large" />, desc: "Overall progress, milestones, and site photos." },
  { label: "Videos", to: "/admin/videos", icon: <VideocamRoundedIcon fontSize="large" />, desc: "Upload update videos and the 3D overview video." },
  { label: "Payment Plans", to: "/admin/payment-plans", icon: <PaymentsRoundedIcon fontSize="large" />, desc: "Manage payment plan cards shown to buyers." },
  { label: "Documents", to: "/admin/documents", icon: <DescriptionRoundedIcon fontSize="large" />, desc: "Brochure, floor plan, payment schedule, elevation image." },
  { label: "Gallery", to: "/admin/gallery", icon: <CollectionsRoundedIcon fontSize="large" />, desc: "Upload and manage gallery photos." },
  { label: "Settings", to: "/admin/settings", icon: <SettingsRoundedIcon fontSize="large" />, desc: "WhatsApp number and phone shown on the site." },
];

const AdminDashboard = () => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Manage the content shown on the public site.
      </Typography>

      <Grid container spacing={2}>
        {cards.map((c) => (
          <Grid item xs={12} sm={6} md={4} key={c.to}>
            <Paper
              component={Link}
              to={c.to}
              elevation={1}
              sx={{
                p: 3,
                display: "block",
                textDecoration: "none",
                color: "inherit",
                transition: "box-shadow .15s",
                "&:hover": { boxShadow: 4 },
              }}
            >
              <Box sx={{ color: "primary.main", mb: 1 }}>{c.icon}</Box>
              <Typography variant="subtitle1" fontWeight={700}>
                {c.label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {c.desc}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
